import { Component, OnInit, signal, computed } from '@angular/core';
import { History } from '../interfaces';
import { doc, onSnapshot, collection, query, where } from 'firebase/firestore';
import { dataStore, dataStoreSignal, db } from 'src/app/app.component';
import { Router } from '@angular/router';
import { NgStyle } from '@angular/common';
import { MatTabGroup, MatTab } from '@angular/material/tabs';
import { BalanceComponent } from './components/balance/balance.component';
import { ProfileContentComponent } from './components/profile-content/profile-content.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
  imports: [
    NgStyle,
    MatTabGroup,
    MatTab,
    BalanceComponent,
    ProfileContentComponent,
    MatProgressSpinner,
  ],
})
export class ProfileComponent implements OnInit {
  ds = dataStoreSignal;
  loaded = signal(false);
  charges = signal<History[]>([]);
  payments = signal<History[]>([]);
  orgUserHistory = computed(() => {
    let history = [];
    this.charges().forEach((charge) => {
      history.push(charge);
    });
    this.payments().forEach((payment) => {
      history.push(payment);
    });
    return history.sort((a, b) => a.date.toDate().getTime() - b.date.toDate().getTime()).reverse();
  });

  constructor(private router: Router) {}

  async ngOnInit(): Promise<any> {
    if (!dataStore.orgUser.name) {
      this.router.navigate(['/first-time']);
    }

    const userRef = doc(db, `users/${this.ds().orgUser.id}`);
    onSnapshot(
      query(
        collection(db, `organisations/${this.ds().selectedOrganisation.id}/charges`),
        where('userRef', '==', userRef),
      ),
      (querySnapshot) => {
        this.charges.set(
          querySnapshot.docs.map((doc) => {
            return { id: doc.id, ...doc.data(), type: 'charge' } as History;
          }),
        );
      },
    );
    onSnapshot(
      query(
        collection(db, `organisations/${this.ds().selectedOrganisation.id}/payments`),
        where('userRef', '==', userRef),
      ),
      (querySnapshot) => {
        this.payments.set(
          querySnapshot.docs.map((doc) => {
            return { id: doc.id, ...doc.data(), type: 'charge' } as History;
          }),
        );
      },
    );
    this.loaded.set(true);
  }
}
